import React from 'react'
import PropTypes from 'prop-types'

import AddIcon from 'Assets/Images/icons/add'

export const TopNavButtonUnstyled = props => (
  <li
    onClick={props.onClickHandler}
    className={props.className + (props.active ? ' active' : '')}
  >
    <div className={'opacity-background'} />
    <AddIcon />
    <div>{props.children}</div>
  </li>
)

TopNavButtonUnstyled.propTypes = {
  active: PropTypes.string,
  className: PropTypes.string,
  onClickHandler: PropTypes.func.isRequired,
}
